<app-module-header
  [title]="(organization?.organizationName ? $safeNavigationMigration(organization?.organizationName) + ' - ' : '') + ('SHUTTLE_PLANNING_PAGE.SHUTTLE_PLANNING' | transloco)"
[icon]="'airport_shuttle'"></app-module-header>

@if (isLoading) {
  <mat-progress-bar class="mb-2" mode="indeterminate"></mat-progress-bar>
}

<div class="container-fluid my-2 px-0">
  <div class="filter-container">
    <mat-form-field appearance="outline">
      <mat-label>{{'SHUTTLE_PLANNING_PAGE.DATE_RANGE' | transloco}}</mat-label>
      <mat-date-range-input [formGroup]="orderShuttlePlanningForm" [rangePicker]="dateRangePicker">
        <input matStartDate formControlName="dateFrom" placeholder="Datum från">
        <input matEndDate formControlName="dateTo" placeholder="Datum till">
      </mat-date-range-input>
      <mat-datepicker-toggle matSuffix [for]="dateRangePicker"></mat-datepicker-toggle>
      <mat-date-range-picker #dateRangePicker></mat-date-range-picker>
    </mat-form-field>

    <mat-form-field appearance="outline" class="ml-3">
      <mat-label>{{'TRANSACTION.FILTER.TITLE' | transloco}}</mat-label>
      <mat-select [(ngModel)]="vehicleFilter">
        <mat-option value="all">{{'CHECKIN_CHECKOUT.FILTER_OPTIONS.ALL' | transloco}}</mat-option>
        <mat-option value="with">{{'SHUTTLE_PLANNING_PAGE.PARKING_CUSTOMERS_WITH_CARS' | transloco}}</mat-option>
        <mat-option value="without">{{'SHUTTLE_PLANNING_PAGE.TRANSFER_CUSTOMERS_FROM_HOTELS' | transloco}}</mat-option>
      </mat-select>
    </mat-form-field>

    <button mat-fab class="ml-3 search-button" color="primary" aria-label="search" (click)="getOrderShuttlesPlanning()">
      <mat-icon class="m-0">search</mat-icon>
    </button>
  </div>

  @for (planDay of orderShuttlePlanReportVM?.orderShuttlePlanDays; track planDay) {
    <mat-card appearance="outlined" class="table-card mb-4"
      >
      <mat-accordion multi>
        <mat-expansion-panel [expanded]="true">
          <mat-expansion-panel-header class="card-header">
            <mat-icon class="m-0">today</mat-icon>
            &nbsp; {{ planDay.dayDate | date: 'yyyy-MM-dd' }}
          </mat-expansion-panel-header>
          <div class="shuttle-day-details-container">
            <div class="custom-table-container shuttle-time-column">
              <div class="custom-table-heading-container">
              </div>
              <table mat-table class="custom-table" [dataSource]="getFilteredHours(planDay.orderShuttlePlanHours)">
                <ng-container matColumnDef="Tid">
                  <th mat-header-cell *matHeaderCellDef> {{'SHUTTLE_PLANNING_PAGE.TIME' | transloco}} </th>
                  <td #timeCell mat-cell *matCellDef="let element">
                  {{ element.fromTimeStr }} - {{ element.toTimeStr }} </td>
                  <td mat-footer-cell *matFooterCellDef> &nbsp; </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumnsTid"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumnsTid;"></tr>
                <tr mat-footer-row *matFooterRowDef="displayedColumnsTid"></tr>
              </table>
            </div>
            <div class="custom-table-container ">
              <div class="custom-table-heading-container">
                <mat-icon class="icon-bottom">flight_land</mat-icon>
                {{'SHUTTLE_PLANNING_PAGE.ARRIVAL' | transloco}}
              </div>
              <table mat-table class="custom-table arrival-table"
                [dataSource]="getFilteredHours(planDay.orderShuttlePlanHours)">
                <ng-container matColumnDef="totalOrders">
                  <th mat-header-cell *matHeaderCellDef>
                    <mat-icon class="custom-table-column-icons">list_alt</mat-icon>
                    <span class="custom-table-column-names">
                      {{'SHUTTLE_PLANNING_PAGE.ORDERS' | transloco}}
                    </span>
                  </th>
                  <td [style.height]="maxHeight" mat-cell *matCellDef="let element">
                    @if (shouldShowArrivalRow(element)) {
                      <span>{{getFilteredArrivalValues(element).totalOrders}}</span>
                    }
                    @if (!shouldShowArrivalRow(element)) {
                      <span class="disabled-cell"></span>
                    }
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                  {{getTotalOrdersArrFiltered(getFilteredHours(planDay.orderShuttlePlanHours))}} </td>
                </ng-container>
                <ng-container matColumnDef="totalPassengers">
                  <th mat-header-cell *matHeaderCellDef>
                    <mat-icon class="custom-table-column-icons">group</mat-icon>
                    <span class="custom-table-column-names">
                      {{'SHUTTLE_PLANNING_PAGE.PERSONS' | transloco}}
                    </span>
                  </th>
                  <td mat-cell *matCellDef="let element">
                    @if (shouldShowArrivalRow(element)) {
                      <span>{{getFilteredArrivalValues(element).totalPassengers}}</span>
                    }
                    @if (!shouldShowArrivalRow(element)) {
                      <span class="disabled-cell"></span>
                    }
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                  {{getTotalPassengersArrFiltered(getFilteredHours(planDay.orderShuttlePlanHours))}} </td>
                </ng-container>
                <ng-container matColumnDef="totalBaggage">
                  <th mat-header-cell *matHeaderCellDef>
                    <mat-icon class="custom-table-column-icons">luggage</mat-icon>
                    <span class="custom-table-column-names">
                      {{'SHUTTLE_PLANNING_PAGE.BAGGAGE' | transloco}}
                    </span>
                  </th>
                  <td mat-cell *matCellDef="let element">
                    @if (shouldShowArrivalRow(element)) {
                      <span>{{getFilteredArrivalValues(element).totalBaggage}}</span>
                    }
                    @if (!shouldShowArrivalRow(element)) {
                      <span class="disabled-cell"></span>
                    }
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                  {{getTotalBaggageArrFiltered(getFilteredHours(planDay.orderShuttlePlanHours))}} </td>
                </ng-container>
                <ng-container matColumnDef="totalChildseats">
                  <th mat-header-cell *matHeaderCellDef>
                    <mat-icon class="custom-table-column-icons">child_care</mat-icon>
                    <span class="custom-table-column-names">
                      {{'SHUTTLE_PLANNING_PAGE.INFANTS' | transloco}}
                    </span>
                  </th>
                  <td mat-cell *matCellDef="let element">
                    @if (shouldShowArrivalRow(element)) {
                      <span>{{getFilteredArrivalValues(element).totalChildseats}}</span>
                    }
                    @if (!shouldShowArrivalRow(element)) {
                      <span class="disabled-cell"></span>
                    }
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                  {{getTotalChildseatsArrFiltered(getFilteredHours(planDay.orderShuttlePlanHours))}} </td>
                </ng-container>
                <ng-container matColumnDef="totalCars">
                  <th mat-header-cell *matHeaderCellDef>
                    <mat-icon class="custom-table-column-icons">directions_car</mat-icon>
                    <span class="custom-table-column-names">
                      {{'SHUTTLE_PLANNING_PAGE.VEHICLES' | transloco}}
                    </span>
                  </th>
                  <td mat-cell *matCellDef="let element">
                    @if (shouldShowArrivalRow(element)) {
                      <span>{{getFilteredArrivalValues(element).totalCars}}</span>
                    }
                    @if (!shouldShowArrivalRow(element)) {
                      <span class="disabled-cell"></span>
                    }
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                  {{getTotalCarsArrFiltered(getFilteredHours(planDay.orderShuttlePlanHours))}} </td>
                </ng-container>
                <ng-container matColumnDef="totalFlights">
                  <th mat-header-cell *matHeaderCellDef>
                    <mat-icon class="custom-table-column-icons">flight</mat-icon>
                    <span class="custom-table-column-names">
                      {{'SHUTTLE_PLANNING_PAGE.FLIGHTS' | transloco}}
                    </span>
                  </th>
                  <td mat-cell *matCellDef="let element">
                    @if (shouldShowArrivalRow(element)) {
                      <span>{{getFilteredArrivalValues(element).totalFlights}}</span>
                    }
                    @if (!shouldShowArrivalRow(element)) {
                      <span class="disabled-cell"></span>
                    }
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                  {{getTotalFlightsArrFiltered(getFilteredHours(planDay.orderShuttlePlanHours))}} </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumnsShuttle"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumnsShuttle;"
                (click)="shouldShowArrivalRow(row) && planningDetails(row.orderShuttleArrival)"></tr>
                <tr mat-footer-row class="font-weight-bold" *matFooterRowDef="displayedColumnsShuttle"></tr>
              </table>
            </div>
            <div class="custom-table-container ">
              <div class="custom-table-heading-container">
                <mat-icon class="icon-bottom">flight_takeoff</mat-icon>
                {{'SHUTTLE_PLANNING_PAGE.DEPARTURE' | transloco}}
              </div>
              <table class="custom-table departure-table" mat-table
                [dataSource]="getFilteredHours(planDay.orderShuttlePlanHours)">
                <ng-container matColumnDef="totalOrders">
                  <th mat-header-cell *matHeaderCellDef>
                    <mat-icon class="custom-table-column-icons">list_alt</mat-icon>
                    <span class="custom-table-column-names">
                      {{'SHUTTLE_PLANNING_PAGE.ORDERS' | transloco}}
                    </span>
                  </th>
                  <td mat-cell [style.height]="maxHeight" *matCellDef="let element">
                    @if (shouldShowDepartureRow(element)) {
                      <span>{{getFilteredDepartureValues(element).totalOrders}}</span>
                    }
                    @if (!shouldShowDepartureRow(element)) {
                      <span class="disabled-cell"></span>
                    }
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                  {{getTotalOrdersDepFiltered(getFilteredHours(planDay.orderShuttlePlanHours))}} </td>
                </ng-container>
                <ng-container matColumnDef="totalPassengers">
                  <th mat-header-cell *matHeaderCellDef>
                    <mat-icon class="custom-table-column-icons">group</mat-icon>
                    <span class="custom-table-column-names">
                      {{'SHUTTLE_PLANNING_PAGE.PERSONS' | transloco}}
                    </span>
                  </th>
                  <td mat-cell *matCellDef="let element">
                    @if (shouldShowDepartureRow(element)) {
                      <span>{{getFilteredDepartureValues(element).totalPassengers}}</span>
                    }
                    @if (!shouldShowDepartureRow(element)) {
                      <span class="disabled-cell"></span>
                    }
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                  {{getTotalPassengersDepFiltered(getFilteredHours(planDay.orderShuttlePlanHours))}} </td>
                </ng-container>
                <ng-container matColumnDef="totalBaggage">
                  <th mat-header-cell *matHeaderCellDef>
                    <mat-icon class="custom-table-column-icons">luggage</mat-icon>
                    <span class="custom-table-column-names">
                      {{'SHUTTLE_PLANNING_PAGE.BAGGAGE' | transloco}}
                    </span>
                  </th>
                  <td mat-cell *matCellDef="let element">
                    @if (shouldShowDepartureRow(element)) {
                      <span>{{getFilteredDepartureValues(element).totalBaggage}}</span>
                    }
                    @if (!shouldShowDepartureRow(element)) {
                      <span class="disabled-cell"></span>
                    }
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                  {{getTotalBaggageDepFiltered(getFilteredHours(planDay.orderShuttlePlanHours))}} </td>
                </ng-container>
                <ng-container matColumnDef="totalChildseats">
                  <th mat-header-cell *matHeaderCellDef>
                    <mat-icon class="custom-table-column-icons">child_care</mat-icon>
                    <span class="custom-table-column-names">
                      {{'SHUTTLE_PLANNING_PAGE.INFANTS' | transloco}}
                    </span>
                  </th>
                  <td mat-cell *matCellDef="let element">
                    @if (shouldShowDepartureRow(element)) {
                      <span>{{getFilteredDepartureValues(element).totalChildseats}}</span>
                    }
                    @if (!shouldShowDepartureRow(element)) {
                      <span class="disabled-cell"></span>
                    }
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                  {{getTotalChildseatsDepFiltered(getFilteredHours(planDay.orderShuttlePlanHours))}} </td>
                </ng-container>
                <ng-container matColumnDef="totalCars">
                  <th mat-header-cell *matHeaderCellDef>
                    <mat-icon class="custom-table-column-icons">directions_car</mat-icon>
                    <span class="custom-table-column-names">
                      {{'SHUTTLE_PLANNING_PAGE.VEHICLES' | transloco}}
                    </span>
                  </th>
                  <td mat-cell *matCellDef="let element">
                    @if (shouldShowDepartureRow(element)) {
                      <span>{{getFilteredDepartureValues(element).totalCars}}</span>
                    }
                    @if (!shouldShowDepartureRow(element)) {
                      <span class="disabled-cell"></span>
                    }
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                  {{getTotalCarsDepFiltered(getFilteredHours(planDay.orderShuttlePlanHours))}} </td>
                </ng-container>
                <ng-container matColumnDef="totalFlights">
                  <th mat-header-cell *matHeaderCellDef>
                    <mat-icon class="custom-table-column-icons">flight</mat-icon>
                    <span class="custom-table-column-names">
                      {{'SHUTTLE_PLANNING_PAGE.FLIGHTS' | transloco}}
                    </span>
                  </th>
                  <td mat-cell *matCellDef="let element">
                    @if (shouldShowDepartureRow(element)) {
                      <span>{{getFilteredDepartureValues(element).totalFlights}}</span>
                    }
                    @if (!shouldShowDepartureRow(element)) {
                      <span class="disabled-cell"></span>
                    }
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                  {{getTotalFlightsDepFiltered(getFilteredHours(planDay.orderShuttlePlanHours))}} </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumnsShuttle"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumnsShuttle;"
                (click)="shouldShowDepartureRow(row) && planningDetails(row.orderShuttleDeparture)"></tr>
                <tr mat-footer-row class="font-weight-bold" *matFooterRowDef="displayedColumnsShuttle"></tr>
              </table>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </mat-card>
  }

</div>